import { formatLocalDate, isPlausibleDate } from "@/utils/dateUtils";

/** Dia de hoje ("YYYY-MM-DD"), valor inicial e limite do campo de data de aprovação. */
export function todayLocalDate(now: Date = new Date()): string {
  return formatLocalDate(now) ?? "";
}

/** A data de aprovação vale se foi preenchida, tem ano plausível e não está no futuro. */
export function isApprovalDateValid(approvalDate: string, today: string = todayLocalDate()): boolean {
  return !!approvalDate && isPlausibleDate(approvalDate) && approvalDate <= today;
}
